import { memo } from 'react'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import { EventKindEntryDialog } from '../eventKindEntryDialog/eventKindEntryDialog'
import { useTranslation } from '@crew/modules/i18n'
import { useModal } from 'components/layouts/modal/useModal'

export const EventKindListToolbar = memo(() => {
  const { t } = useTranslation()

  const [
    isEventKindEntryDialogOpen,
    openEventKindEntryDialog,
    closeEventKindEntryDialog,
  ] = useModal()

  return (
    <>
      <div className="w-full flex gap-x-2.5">
        <div className="flex flex-1">
          <CrewButton
            type="primary"
            className="ml-auto"
            text={t('action.newEventKind')}
            onClick={openEventKindEntryDialog}
          />
        </div>
      </div>

      <EventKindEntryDialog
        isEditMode={false}
        title={t('label.eventKindAdd')}
        isOpen={isEventKindEntryDialogOpen}
        onClose={closeEventKindEntryDialog}
      />
    </>
  )
})
